import React, { useState, useEffect } from 'react';
import AddUnit from './AddUnit';
import { Modal, Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap"
import AddUnitmodal from './AddUnitmodal';
import Editunitmodal from './Editunitmodal';
const jsonData = [
	{

		id: "",
		name: "",
		description: '',
		selling: '',
		regular: '',
		offer: ''
	},

];
function TableData({ variant, onAdd, setVariantsData, unitliststore, onDelete }) {
	const [open, setOpen] = useState(false);
	const [openEdit, setOpenEdit] = useState(false);
	const [editdata, seteditdata] = useState([])

	const toggleStatus = (variantId) => {
		const updatedVariant = variant.find(vari => vari.uid === variantId);
		if (updatedVariant) {
			const newVariant = { ...updatedVariant, status: !updatedVariant.status };
			onAdd(newVariant);
		}
	};


	// console.log(editdata,"das")

	// console.log(variant,"variant")


	const onOpenModal = () => {
		setOpen(true);
	};

	const onCloseModal = () => {
		setOpen(false);
	};
	const onOpenModalEdit = () => {
		setOpenEdit(true);
	};

	const onCloseModalEdit = () => {
		setOpenEdit(false);
	};
	const deletedata = (id) => {
		onDelete(id)

	}

	const Editdata = (id) => {
		const result = variant.find((item) => item.uid === id
		)

		seteditdata(result)
		if (editdata) {
			onOpenModalEdit()

		}



	}

	const tableRows = variant?.map((info) => {
		return (
			<tr key={info.uid}>
				<td>{info.id.label}</td>
				<td>{info.name}</td>
				{/* <td>{info.description}</td> */}
				<td>{info.selling ? info.selling : "-"}</td>
				<td>{info.regular}</td>
				<td>{info.offer ? info.offer : "-"}</td>
				<td>{info.stock ? info.stock : "-"}</td>
				<td>{info.weight ? info.weight : "-"}</td>
				{/* <td>{info.height ? info.height : "-"}</td>
				<td>{info.length ? info.length : "-"}</td> */}
				<td>
					<label className="switch">
						<input
							type="checkbox"
							checked={info.status !== false}
							onChange={() => toggleStatus(info.uid)}
						/>
						<span className="slider round"></span>
					</label>
				</td>
				<td><span onClick={() => Editdata(info.uid)}>

					<i
						className="fa fa-edit"
						style={{
							width: 35,
							fontSize: 20,
							padding: 11,
							color: "blue",
							cursor: "pointer"
						}}
					></i>
				</span>
					<span onClick={() => deletedata(info.uid)}>

						<i
							className="fa fa-trash"
							style={{
								width: 35,
								fontSize: 20,
								padding: 11,
								color: "#e4566e",
								cursor: "pointer"
							}}
						></i>
					</span></td>
			</tr>
		);
	});

	const addRows = (data) => {
		// (data,"dsdssdssds")
		// const totalVariants = variantsData.length;
		// data.id = totalVariants;
		// const updatedVariantsData = [...variantsData];
		// updatedVariantsData.push(data);
		// setVariantsData(updatedVariantsData);
		onAdd(data)
	};



	return (
		<div>
			<style>
				{`
					.switch {
						position: relative;
						display: inline-block;
						width: 60px;
						height: 34px;
					}

					.switch input {
						opacity: 0;
						width: 0;
						height: 0;
					}

					.slider {
						position: absolute;
						cursor: pointer;
						top: 0;
						left: 0;
						right: 0;
						bottom: 0;
						background-color: #ccc;
						-webkit-transition: .4s;
						transition: .4s;
					}

					.slider:before {
						position: absolute;
						content: "";
						height: 26px;
						width: 26px;
						left: 4px;
						bottom: 4px;
						background-color: white;
						-webkit-transition: .4s;
						transition: .4s;
					}

					input:checked + .slider {
						background-color: #2196F3;
					}

					input:focus + .slider {
						box-shadow: 0 0 1px #2196F3;
					}

					input:checked + .slider:before {
						-webkit-transform: translateX(26px);
						-ms-transform: translateX(26px);
						transform: translateX(26px);
					}

					.slider.round {
						border-radius: 34px;
					}

					.slider.round:before {
						border-radius: 50%;
					}
				`}
			</style>
			<div style={{ display: "flex", justifyContent: "flex-end", paddingTop: 10, paddingBottom: 10 }}>
				<Button onClick={onOpenModal}>Add Unit</Button>
			</div>
			<table className="table table-stripped">
				<thead>
					<tr>
						<th>Unit</th>
						<th>Variant Name</th>
						{/* <th>Variant Description</th> */}
						<th>Selling Price</th>
						<th>Maximum Retail Price</th>
						<th>Offer Price</th>
						<th>Stock</th>
						<th>Weight</th>
						{/* <th>Height(cm)</th>
						<th>Length(cm)</th> */}
						<th>Status</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>{tableRows}</tbody>
			</table>


			{open && <AddUnitmodal openModal={open} onCloseModal={() => setOpen(false)} func={addRows} unitlistmap={unitliststore} />}
			{openEdit && <Editunitmodal openModal={openEdit} onCloseModal={() => setOpenEdit(false)} editdata={editdata} func={onAdd} variant={variant} setVariantsData={setVariantsData} />}
		</div>
	);
}

export default TableData;